// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import questionnaireReducer from './QuestionnaireSlice';

const store = configureStore({
  reducer: {
    questionnaire: questionnaireReducer
  }
});

export default store;